import axios from "axios";
import { browserHistory } from "react-router";
import { clearAuthSession, markSkipNextSessionRestore } from "../utils/authSession";

const AUTH_PERSIST_KEY = "reduxPersist:authentication";

function clearPersistedAuthenticationState() {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.removeItem(AUTH_PERSIST_KEY);
  } catch (error) {
    // Ignore persistence cleanup issues.
  }
}

export function setUserData(user) {
  return (dispatch) => dispatch({ type: "USER_DATA", payload: user });
}

export function setAuthToken() {
  return (dispatch) => {
    dispatch({ type: "LOGIN_SUCCESS" });
  };
}

export function logout(error) {
  return (dispatch) => {
    clearAuthSession();
    clearPersistedAuthenticationState();
    dispatch({ type: "LOGOUT", error: error || null });
  };
}

export function logoutRequest() {
  return async function (dispatch) {
    try {
      await axios.post(
        "/v2/auth/logout/",
        {},
        {
          withCredentials: true,
          skipAuthRefresh: true,
          skipAuthToken: true,
          validateStatus: (status) => status >= 200 && status < 300
        }
      );
    } catch (error) {
      console.warn("Logout request failed.", error);
    } finally {
      markSkipNextSessionRestore();
      dispatch(logout());
      browserHistory.push("/login");
    }
  };
}



// WEBPACK FOOTER //
// ./actions/authentication.js